module.exports = {
  "dashboardInteraction": {
    "name": "dashboard-interaction",
    "class": "interaction",
    "properties": {
      "emptyStateInteraction": {
        "type": "string",
        "isOptional": true
      },
      "sorting": {
        "type": "string",
        "isOptional": true
      },
      "hasCloneFromAccountToBusinessUnit": {
        "type": "string",
        "isOptional": true
      },
      "hasCloneFromBusinessUnitToBusinessUnit": {
        "type": "string",
        "isOptional": true
      },
      "filterType": {
        "type": "string",
        "isOptional": true
      },
      "actionType": {
        "type": "string",
        "isOptional": true
      },
      "hasCloneFromBusinessUnitToAccount": {
        "type": "string",
        "isOptional": true
      },
      "action": {
        "type": "string",
        "isOptional": true
      },
      "newPostSend": {
        "type": "string",
        "isOptional": true
      },
      "linkClicked": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen2": {
        "type": "string",
        "isOptional": true
      },
      "otherActions": {
        "type": "string",
        "isOptional": true
      },
      "lockedScreenType": {
        "type": [
          "asset",
          "tool"
        ],
        "isOptional": true
      },
      "clickMoreTools": {
        "type": "string",
        "isOptional": true
      },
      "filtering": {
        "type": "string",
        "isOptional": true
      },
      "viewSection": {
        "type": "string",
        "isOptional": true
      },
      "dashboardColumn": {
        "type": "string",
        "isOptional": true
      },
      "dashboardColumnLength": {
        "type": "number",
        "isOptional": true
      },
      "dashboardOnboardingCompletedStepsV2": {
        "type": "array",
        "isOptional": true
      },
      "dashboardOnboardingStartActionV2": {
        "type": "string",
        "isOptional": true
      },
      "dashboardOnboardingMigrationAction": {
        "type": "string",
        "isOptional": true
      },
      "onboardingChecklistAction": {
        "type": "string",
        "isOptional": true
      },
      "onboardingTourAction": {
        "type": "string",
        "isOptional": true
      },
      "onboardingChecklistCompletedSteps": {
        "type": "array",
        "isOptional": true
      },
      "pqlAction": {
        "type": "string",
        "isOptional": true
      },
      "willTriggerOnboarding": {
        "type": "boolean",
        "isOptional": true
      },
      "assetAccessAction": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "email"
  }
};